<template>

    <div class="app container">

        <div class="codeBox" v-if="!auth && !token && !preview" v-cloak>
            <!--
            This is the form that allows the user to enter the ShortURL code to be redirected to an evaluation or test.
            -->
            <form @submit="gotoShortUrl">
                <div>
                    <input type="text" v-model="short_code" class="form-control" :placeholder="t('live_enter_code_here')">
                </div>
                <div>
                    {{ short_code_notice }}
                </div>
                <div>
                    <input type="submit" :value="t('live_goto_next')" class="btn btn-block btn-primary">
                </div>
            </form>
        </div>

        <span v-if="auth">
            <div v-if="!show_flags" class="empty-flag-placeholder"></div>
             <div class="language-flags" style="text-align: right;" v-if="!preview && show_flags">
                <a @click="loadEvaluation('sv-SE')">
                    <country-flag v-if="language_id ==='sv-SE'" country='se' size='big'/>
                    <country-flag v-else country='se' size='normal'/>
                </a>
<!--                <a @click="loadEvaluation('no')">-->
<!--                    <country-flag v-if="language_id ==='no'" country='no' size='big'/>-->
<!--                    <country-flag v-else country='no' size='normal'/>-->
<!--                </a>-->
                <a @click="loadEvaluation('en')">
                    <country-flag v-if="language_id ==='en'" country='gb' size='big'/>
                    <country-flag v-else country='gb' size='normal'/>
                </a>
                <a @click="loadEvaluation('pl')">
                    <country-flag v-if="language_id ==='pl'" country='pl' size='big'/>
                    <country-flag v-else country='pl' size='normal'/>
                </a>
<!--                <a @click="loadEvaluation('de-DE')">-->
<!--                    <country-flag v-if="language_id ==='de-DE'" country='de' size='big'/>-->
<!--                    <country-flag v-else country='de' size='normal'/>-->
<!--                </a>-->
                <a @click="loadEvaluation('ru')">
                    <country-flag v-if="language_id ==='ru'" country='ru' size='big'/>
                    <country-flag v-else country='ru' size='normal'/>
                </a>
                <a @click="loadEvaluation('lt-LT')">
                    <country-flag v-if="language_id ==='lt-LT'" country='lt' size='big'/>
                    <country-flag v-else country='lt' size='normal'/>
                </a>
            </div>
            <Evaluation :evaluation="evaluation"
                        :settings="settings"
                        :sections="sections"
                        :user="user"
                        :profile_edit_notice="profile_edit_notice"
                        :user_provider="user_provider"
                        :language_id ="language_id"
                        :preview="preview"
                        :token="token">
            </Evaluation>
        </span>
        <span v-else>
            <unauthorized :error="error"></unauthorized>
        </span>
    </div>
</template>

<script>
    import axios from 'axios'
    import Evaluation from './components/Evaluation.vue'
    import Unauthorized from "./components/Unauthorized.vue"
    import CountryFlag from 'vue-country-flag'
    import Vue from 'vue';



    export default {
        name: 'app',
        components: {
            Evaluation,
            Unauthorized,
            CountryFlag
        },

        data() {
            return {
                evaluation: {},
                settings: {},
                sections: [],
                user: {},
                user_provider: {},
                auth: false,
                show_flags: false,
                response: {},
                preview: false,
                token: null,
                error: null,
                language_id: null,
                profile_edit_notice : '',

                short_code: '',
                short_code_notice: ''

            }
        },
        methods: {
            t : function(key){
                let phrase = this.$phrasePlugin.translate(key);
                return phrase === key ? '' : phrase;
            },
            gotoShortUrl : function(e){
                e.preventDefault();
                this.short_code_notice = '';
                if(this.short_code){
                    let url = 'https://internal.api.frontcore.com/shorturl/validate/' + this.short_code;
                    axios.get(url).then(function (response) {
                        window.location.href = 'https://internal.api.frontcore.com/' + this.short_code;
                    }.bind(this))
                        .catch(err => {
                         this.short_code_notice = this.t('enter_a_valid_code');
                        });


                }
            },

            createSectionsFromData : function(unprocessed_sections, unprocessed_answers){
              const sections = [...unprocessed_sections];
              const answers = [...unprocessed_answers];

              answers.map((answer) => {
                  if(answer.question.question_type_id == 5 && !answer.hasOwnProperty('multiple_answers_ids')){
                    // multiple_answers must be an array for Vue to consider it as a multi checkbox select.
                    Vue.set(answer, 'multiple_answers_ids', [])
                  }
                  return answer;
              })

              const processed_sections = [];
              sections.forEach( section => {
                const result = answers.filter( answer => answer.question.evaluation_section_id === section.id );

                processed_sections.push({
                  id: section.id,
                  title: section.title,
                  answers: result
                });

                result.forEach(function (answer) {
                  const index = answers.indexOf(answer);
                  if (index !== -1) {
                    answers.splice(index, 1);
                  }
                });
              });

              if(answers.length){
                processed_sections.push({
                  id : 'unassigned',
                  title: '',
                  answers : answers
                });
              }

              return {
                sections: processed_sections
              }

            },

            loadEvaluation: function (language = null) {

                this.token = this.$router.currentRoute.query.api_token;
                this.preview = this.$router.currentRoute.query.preview;
                let uuid = this.$router.currentRoute.query.id;


                //todo: change this to be more effective
                // let params = this.$router.currentRoute.path.split('/');
                // this.token = params[2];
                if (this.token) {
                    let url = 'user/evaluation/' + uuid + '/' + this.token;
                    if (language) {
                        url = 'user/evaluation/' + uuid + '/' + this.token + '/' + language;
                        this.language_id = language;
                    }

                    axios.get(url).then(function (response) {

                        this.evaluation = response.data.evaluation;
                        this.settings = response.data.settings ? response.data.settings : {};
                        this.user = response.data.user;
                        this.show_flags = response.data.show_flags;
                        this.profile_edit_notice = response.data.profile_edit_notice;
                        this.user_provider = response.data.user_provider;

                      /**
                       * Data from the server come with sections and answers in separated form.
                       * This function will fill each section with answers and questions.
                       * Any unassigned questions/answers will be assigned a new section with id: 'unassigned'
                       */
                      const {sections} = this.createSectionsFromData(
                            response.data.evaluation.sections,
                            this.user.last_attempt.answers
                        );
                        this.sections = sections;

                        if(!this.language_id){
                            this.language_id = this.user.language_id;

                            if(!this.language_id && response.data.provider_language_id){
                              this.language_id =  response.data.provider_language_id;
                            }
                        }

                          this.$phrasePlugin.setLanguageId(this.language_id);

                        this.auth = true;
                    }.bind(this))
                        .catch(err => {
                            this.error = err.response;
                            // console.log(this.error);
                            if (err.response.status === 401) {
                                this.auth = false;
                            }
                            if (err.response.status === 403) {
                                this.auth = false;
                            }

                            if (err.response.status === 409) {
                                this.auth = false;
                            }
                        });
                } else if (this.preview) {
                    let url = 'evaluation/preview/' + uuid;
                    if (language) {
                        url = 'evaluation/preview/' + uuid + '/' + language;
                        this.language_id = language;
                    }

                    axios.get(url).then(function (response) {
                        this.evaluation = response.data.evaluation;
                        this.user = response.data.user;
                        this.auth = true;
                        this.preview = true;
                        const {sections} = this.createSectionsFromData(
                            response.data.evaluation.sections,
                            response.data.evaluation.preview_questions
                        );
                        this.sections = sections;


                    }.bind(this))
                        .catch(err => {
                            if (err.response.status === 401) {
                                this.auth = false;
                            }
                        });
                } else {
                    this.auth = false;
                }
            }
        },
        mounted() {
            this.loadEvaluation();
            if(!this.$router.currentRoute.query.api_token){
                this.$phrasePlugin.setLanguageId('no');
            }

        }
    }
</script>



<style>
    html, body {
        height: 100%;
        margin: 0;
        font-family: 'Inter', sans-serif;
        /*font-family: 'Open Sans', sans-serif;*/
      /*background:#f8fafb;*/
    }

    .app {
        font-family: "Lucida Sans Unicode", "Lucida Grande", sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        height: 100%;
        padding: 0;
        color: #2c3e50;
    }

    .container {
        padding-right: 15px;
        padding-left: 15px;
    }

    .language-flags {
        cursor: pointer;
    }

    .empty-flag-placeholder { height:70px;}

    .codeBox {
        width: 300px;
        height: 200px;
        position:absolute; /*it can be fixed too*/
        left:0; right:0;
        top:0; bottom:0;
        margin:auto;

        /*this to solve "the content will not be cut when the window is smaller than the content": */
        max-width:100%;
        max-height:100%;
        overflow:auto;
    }
    .codeBox input[type=text]{
        font-weight: bold;
        font-size: 20px;
        margin-bottom:3px;
    }
    .codeBox input[type=submit]{
        margin-top:13px;
    }

</style>



